import { Typography } from 'components/Contentful'
import { Button } from '@achieve/ascend'
import { useHeloc } from './HelocContext'

export const FormText = () => {
  const { state, dispatch } = useHeloc()
  return (
    <div className="flex flex-col gap-4">
      <Typography variant="bodySm" className="text-gray-500" content={state.infoText} />
      <Button
        onClick={() => {
          dispatch({ type: 'SET_MODAL_INFO_STATUS', payload: false })
        }}
        color="primary"
        variant="contained"
        className="w-full"
      >
        Close
      </Button>
    </div>
  )
}
